import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './LostFoundPage.css';

const LostFoundPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Form State
  const [status, setStatus] = useState('lost');
  const [itemName, setItemName] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  // --- THIS useEffect IS THE CORRECTED VERSION ---
  useEffect(() => {
    // Define the async function *inside* the effect
    const loadItems = async () => {
      try {
        setLoading(true);
        setError(''); // Clear previous errors
        const res = await axios.get(`${apiUrl}/api/lostfound`);
        setItems(res.data);
      } catch (err) {
        console.error('Error fetching items:', err);
        setError('Failed to load items. Please try refreshing.');
      } finally {
        // Ensure loading is set to false even on error
        setLoading(false);
      }
    };

    // Call the async function
    loadItems();

  }, [apiUrl]); // Include apiUrl as a dependency
  // --- End of corrected useEffect ---

  // Handle form submission (Unchanged)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!itemName || !description) {
      alert('Item Name and Description are required.');
      return;
    }
    setSubmitting(true);
    setError('');

    try {
      const newItem = { status, itemName, description, location, contactInfo };
      const res = await axios.post(`${apiUrl}/api/lostfound`, newItem);
      setItems([res.data, ...items]); // Add new item to the top

      // Clear form
      setItemName('');
      setDescription('');
      setLocation('');
      setContactInfo('');
      setStatus('lost');
    } catch (err) {
      console.error('Error posting item:', err.response?.data || err);
      setError(err.response?.data?.message || 'Failed to post item.');
    } finally {
      setSubmitting(false);
    }
  };

  // Handle item deletion (Unchanged)
  const handleDelete = async (itemId) => {
    if (!window.confirm('Are you sure you want to delete this post?')) {
      return;
    }
    try {
      await axios.delete(`${apiUrl}/api/lostfound/${itemId}`);
      setItems(items.filter(item => item._id !== itemId)); // Remove visually
    } catch (err) {
      console.error('Error deleting item:', err.response?.data || err);
      alert(err.response?.data?.message || 'Failed to delete item.');
    }
  };

  // --- JSX Return (Unchanged) ---
  return (
    <div className="lost-found-container">
      {/* --- Column 1: Form --- */}
      <div className="lost-found-form-card">
        <h3>Report an Item</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group status-toggle">
            <label>Status:</label>
            <button
              type="button"
              className={status === 'lost' ? 'active' : ''}
              onClick={() => setStatus('lost')}
            >
              Lost
            </button>
            <button
              type="button"
              className={status === 'found' ? 'active' : ''}
              onClick={() => setStatus('found')}
            >
              Found
            </button>
          </div>
          <div className="form-group">
            <label htmlFor="itemName">Item Name</label>
            <input
              type="text" id="itemName"
              value={itemName} onChange={(e) => setItemName(e.target.value)}
              placeholder="e.g., Black Backpack, ID Card" required
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description" value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Provide details like brand, color, distinguishing features..." required
              rows="3"
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="location">Location (Optional)</label>
            <input
              type="text" id="location"
              value={location} onChange={(e) => setLocation(e.target.value)}
              placeholder="e.g., Near Library Cafe, AB1 Ground Floor"
            />
          </div>
          <div className="form-group">
            <label htmlFor="contactInfo">Contact Info (Optional)</label>
            <input
              type="text" id="contactInfo"
              value={contactInfo} onChange={(e) => setContactInfo(e.target.value)}
              placeholder="e.g., Email, Phone, 'Ask at Reception'"
            />
          </div>
          {error && <p className="form-error">{error}</p>}
          <button type="submit" className="btn-submit-item" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Post Item'}
          </button>
        </form>
      </div>

      {/* --- Column 2: Item List --- */}
      <div className="lost-found-list-container">
        <h3>Lost & Found Board</h3>
        {loading && <div className="loading-spinner">Loading items...</div>}
        {!loading && items.length === 0 && <p>No items reported yet.</p>}
        {!loading && items.length > 0 && (
          <div className="item-list">
            {items.map(item => (
              <div key={item._id} className={`item-card ${item.status}`}>
                <span className={`item-status-badge ${item.status}`}>
                  {item.status === 'lost' ? 'LOST' : 'FOUND'}
                </span>
                <h4>{item.itemName}</h4>
                <p className="item-description">{item.description}</p>
                {item.location && <p className="item-detail"><strong>Location:</strong> {item.location}</p>}
                {item.contactInfo && <p className="item-detail"><strong>Contact:</strong> {item.contactInfo}</p>}
                <p className="item-date">
                  Posted: {new Date(item.datePosted).toLocaleDateString()}
                </p>
                <button
                  className="btn-delete-item"
                  onClick={() => handleDelete(item._id)}
                >
                  Delete Post
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LostFoundPage;